import { Component } from 'react';

import TriggerContext from '../TriggerContext';

export class TriggerState extends Component {
  static contextType = TriggerContext;
  componentDidMount() {
    const trigger = this.context.getTrigger(this.props.id);

    if (this.props.onOpen) {
      trigger.onOpen(this.props.onOpen);
    }

    if (this.props.onClose) {
      trigger.onClose(this.props.onClose);
    }
  }

  componentDidUpdate(props) {
    if (this.props.isOpen === props.isOpen) {
      return;
    }

    const trigger = this.context.getTrigger(this.props.id);

    if (!trigger.anchor) {
      return;
    }

    if (this.props.isOpen) {
      if (!trigger.isOpen) {
        trigger.open(trigger.anchor)();
      }
    } else {
      if (trigger.isOpen) {
        trigger.close();
      }
    }
  }

  render() {
    return null;
  }
}

TriggerState.displayName = 'TriggerControls';

export default TriggerState;
